import { atom } from "recoil";

const mediaState = atom<{ sm: boolean; md: boolean; lg: boolean }>({
    key: "mediaState",
    default: {
        sm: window.matchMedia(`(max-width: 779px)`).matches,
        md: window.matchMedia(`(min-width: 780px) and (max-width: 1279px)`).matches,
        lg: window.matchMedia(`(min-width: 1280px)`).matches,
    },
});

export default mediaState;
